"use client";

import { Crisp } from "crisp-sdk-web";
import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";
import { readLocal, writeLocal } from "@/helpers/safeStorage";

// Le chat Crisp ne se charge qu'à la demande. Son script pose ses cookies dès
// qu'il se charge : tant que le visiteur n'a pas ouvert le chat, on n'affiche
// qu'un bouton maison, qui ne contacte pas Crisp. Au clic, Crisp se charge et
// s'ouvre : c'est un service qu'il a expressément demandé, ses cookies n'ont
// donc pas besoin d'un consentement préalable (règles de la CNIL).
//
// Une fois le chat ouvert, on s'en souvient : aux visites suivantes, Crisp se
// charge directement et le visiteur retrouve sa conversation.
const CHAT_DEJA_OUVERT = "blvmy_crisp_opened";

let crispConfigure = false;

function chargerCrisp() {
    if (!crispConfigure) {
        Crisp.configure(process.env.TOKEN_CRISP, { autoload: false });
        crispConfigure = true;
    }
    Crisp.load();
    Crisp.chat.show();
}

export default function CrispChatbox() {
    const t = useTranslations();
    const [charge, setCharge] = useState(false);

    useEffect(() => {
        if (readLocal(CHAT_DEJA_OUVERT) === "1") {
            chargerCrisp();
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setCharge(true);
        }
        return () => {
            if (crispConfigure) Crisp.chat.hide();
        };
    }, []);

    const ouvrir = () => {
        writeLocal(CHAT_DEJA_OUVERT, "1");
        chargerCrisp();
        Crisp.chat.open();
        setCharge(true);
    };

    if (charge) return null;

    return (
        <button
            type="button"
            onClick={ouvrir}
            aria-label={t("crisp_open_chat")}
            title={t("crisp_open_chat")}
            className="fixed bottom-5 right-6 z-[1000] flex h-[60px] w-[60px] items-center justify-center rounded-full bg-primary text-white shadow-lg transition-transform duration-200 hover:scale-105 focus:outline-hidden focus-visible:ring-4 focus-visible:ring-primary/30"
        >
            <SolarIcon name="chat-round-line-bold-duotone" className="text-[28px]" />
        </button>
    );
}
